import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "q-dialog__header-content" };
const _hoisted_2 = { class: "title" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_q_btn = _resolveComponent("q-btn");
    const _component_q_card_section = _resolveComponent("q-card-section");
    const _component_q_spinner = _resolveComponent("q-spinner");
    const _component_q_card = _resolveComponent("q-card");
    const _component_q_dialog = _resolveComponent("q-dialog");
    const _directive_close_popup = _resolveDirective("close-popup");
    return (_openBlock(), _createBlock(_component_q_dialog, {
        class: "q-dialog--component",
        "transition-duration": "200",
        modelValue: _ctx.$q.store.dialog.show,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.$q.store.dialog.show) = $event)),
        onHide: _cache[2] || (_cache[2] = ($event) => (_ctx.$q.store.dialog.hide())),
        persistent: _ctx.$q.store.dialog.persistent
    }, {
        default: _withCtx(() => [
            _createVNode(_component_q_card, null, {
                default: _withCtx(() => [
                    _createVNode(_component_q_card_section, { class: "q-dialog__header" }, {
                        default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_1, [
                                _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$q.store.dialog.title), 1)
                            ]),
                            (!_ctx.$q.store.dialog.persistent)
                                ? _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                                    key: 0,
                                    icon: "close",
                                    flat: "",
                                    round: "",
                                    dense: ""
                                }, null, 512)), [
                                    [_directive_close_popup]
                                ])
                                : _createCommentVNode("", true)
                        ]),
                        _: 1
                    }),
                    _createVNode(_component_q_card_section, {
                        class: "q-dialog__body",
                        innerHTML: _ctx.sanitizedContent
                    }, null, 8, ["innerHTML"]),
                    _createVNode(_component_q_card_section, {
                        class: _normalizeClass(["q-dialog__footer", _ctx.$q.store.dialog.loading ? 'loading' : ''])
                    }, {
                        default: _withCtx(() => [
                            (!_ctx.$q.store.dialog.loading)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    (_ctx.$q.store.dialog.cancel)
                                        ? _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                                            key: 0,
                                            class: "q-mr-sm",
                                            flat: "",
                                            label: _ctx.$q.store.dialog.cancel.label ? _ctx.$q.store.dialog.cancel.label : 'CANCEL'
                                        }, null, 8, ["label"])), [
                                            [_directive_close_popup]
                                        ])
                                        : _createCommentVNode("", true),
                                    _withDirectives(_createVNode(_component_q_btn, {
                                        unelevated: "",
                                        label: _ctx.$q.store.dialog.ok && _ctx.$q.store.dialog.ok.label ? _ctx.$q.store.dialog.ok.label : 'OK',
                                        color: _ctx.$q.store.dialog.ok && _ctx.$q.store.dialog.ok.color ? _ctx.$q.store.dialog.ok.color : 'primary',
                                        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$q.store.dialog.ok && _ctx.$q.store.dialog.ok.fn ? _ctx.$q.store.dialog.ok.fn() : undefined))
                                    }, null, 8, ["label", "color"]), [
                                        [_directive_close_popup, !_ctx.$q.store.dialog.ok || !_ctx.$q.store.dialog.ok.fn]
                                    ])
                                ], 64))
                                : (_openBlock(), _createBlock(_component_q_spinner, {
                                    key: 1,
                                    color: "orange",
                                    size: "2em"
                                }))
                        ]),
                        _: 1
                    }, 8, ["class"])
                ]),
                _: 1
            })
        ]),
        _: 1
    }, 8, ["modelValue", "persistent"]));
}
